import gql from 'graphql-tag';
import {userFragment, addressFragment} from '../fragments';

export default gql`
  query currentUser {
    currentUser {
      ...userFragment
      payjpCustomer {
        id
        card {
          id
          cardId
          customerId
          created
          name
          last4
          expMonth
          expYear
        }
      }
      address {
        ...addressFragment
        industryType {
          id
        }
      }
    }
  }
  ${userFragment}
  ${addressFragment}
`;
